import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { GetAllQuestions, DeleteQuestion, GetAllLevels } from '../services/questionservice';
import { GetAllSubjects } from '../services/isubjectservice';
import Spinner from '../components/Spinner'; // Optional: Add a spinner for loading

function Question() {
    const [questions, setQuestions] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [totalCount, setTotalCount] = useState(0);
    const [subjectpk, setSubjectPk] = useState(0);
    const [level, setLevel] = useState(0);
    const [subject, setSubject] = useState('');
    const [qlevels, setQLevels] = useState([]);
    const [iscode, setIsCode] = useState(-1);
    const [loading, setLoading] = useState(false);

    const location = useLocation();
    const { successMessage } = location.state || {};
    let navigate = useNavigate();
    const totalPages = Math.ceil(totalCount / pageSize);

    useEffect(() => {
        fetchQuestions(subjectpk, level, iscode, page, pageSize);
        fillSubject();
        fetchQLevels();
        toast(successMessage);
    }, []);

    const fetchQuestions = async (subject_pk, level_pk, iscode, currentPage = 1, currentPageSize = 50) => {
        setLoading(true);
        const response = await GetAllQuestions(subject_pk, level_pk, iscode, currentPage, currentPageSize);
        const jsonData = typeof response === 'string' ? JSON.parse(response) : response;
        setQuestions(jsonData.question || []);
        setTotalCount(jsonData.totalCount || 0);
        setLoading(false);
    };

    const fetchQLevels = async () => {
        const data = await GetAllLevels();
        const jsonLevelList = JSON.parse(data);
        setQLevels(jsonLevelList || []);
    };

    const fillSubject = async () => {
        try {
            const dataList = await GetAllSubjects();
            const jsonDataList = JSON.parse(dataList);
            setSubject(jsonDataList);
        } catch (error) {
            console.error('Error fetching the data:', error);
            setLoading(false);
        }
    }

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this question?')) {
            await DeleteQuestion(id);
            fetchQuestions(subjectpk, level, iscode);
        }
    };

    const handleEdit = (id) => {
        navigate('/question/add?pk=' + id);
    };

    const handleSubjectChange = (id) => {
        setSubjectPk(id);
        fetchQuestions(id, level, iscode);
    };
    const handleLevelChange = (id) => {
        setLevel(id);
        fetchQuestions(subjectpk, id, iscode);
    };

    const handleIsCodeChange = (e) => {
        const clickedValue = (e.target.checked == false) ? 0 : 1;
        setIsCode(clickedValue);
        fetchQuestions(subjectpk, level, clickedValue);
    };

    const changePage = (p) => {
        if (p >= 1 && p <= totalPages) setPage(p);
    };

    const pageNumbers = () => {
        const pages = [];
        let start = Math.max(1, page - 2);
        let end = Math.min(totalPages, page + 2);

        if (start > 1) pages.push(1, '...');
        for (let i = start; i <= end; i++) pages.push(i);
        if (end < totalPages) pages.push('...', totalPages);

        return pages;
    };

    const startItem = (page - 1) * pageSize + 1;
    const endItem = Math.min(page * pageSize, totalCount);

    return (
        <>
         {loading && <Spinner overlay={true} text="Loading pages..." />}
            <div class="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card shadow-sm">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <p class="card-title mb-0">Questions</p>
                                </div>
                                <div class="col-md-3">
                                    <select class="form-control dropdown" onChange={(e) => handleSubjectChange(e.target.value)} value={subjectpk}>
                                        <option value="">Subject</option>
                                        {subject && subject.map((item) => (
                                            <option value={item.pk}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <select class="form-control dropdown" onChange={(e) => handleLevelChange(e.target.value)} value={level}>
                                        <option value="">Level</option>
                                        {qlevels && qlevels.map((item) => (
                                            <option value={item.key}>{item.value}</option>
                                        ))}
                                    </select>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="txtQuestion" className='checkbox-label'>Is Code?</label>
                                        <input
                                            type="checkbox"
                                            name="txtcode"
                                            onChange={handleIsCodeChange}
                                        />
                                    </div>
                                </div>
                                <div class="col-md-2 right-align">
                                    <Link to="/question/add" className='nav-link'>
                                        <button type="submit" class="btn btn-primary me-2">New Question</button>
                                    </Link>
                                </div>
                            </div>

                            <div className="table-responsive position-relative">
                                <table className="table table-striped table-hover table-borderless align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Pk</th>
                                            <th>Question</th>
                                            <th>Subject</th>
                                            <th>Level</th>
                                            <th>Is Code</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            questions?.map((item) => (
                                                <tr>
                                                    <td>{item.pk}</td>
                                                    <td>{item.question}</td>
                                                    <td>{item.subjectname}</td>
                                                    <td>{item.levelname}</td>
                                                    <td>{item.iscode ? "True" : "False"}</td>
                                                    <td>
                                                        <i
                                                            className="mdi mdi-tooltip-edit mdi-big font20 pointer"
                                                            title="Edit Record"
                                                            onClick={() => handleEdit(Number(item.pk))}
                                                        ></i>
                                                        <i
                                                            className="mdi mdi-delete mdi-big font20 pointer"
                                                            title="Delete Record"
                                                            onClick={() => handleDelete(item.pk)}
                                                        ></i>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination & Page Info */}
                            <div className="d-flex justify-content-between align-items-center mt-4 p-3 bg-light rounded">
                                <div className="d-flex align-items-center">
                                    <span className="text-muted">
                                        Showing <strong>{startItem}-{endItem}</strong> of <strong>{totalCount}</strong> Records
                                    </span>
                                </div>

                                <div className="d-flex align-items-center">
                                    <button
                                        className="btn btn-outline-primary btn-sm me-2"
                                        onClick={() => changePage(page - 1)}
                                        disabled={page === 1 || loading}
                                    >
                                        <i className="mdi mdi-chevron-left me-1"></i> Previous
                                    </button>

                                    <div className="btn-group mx-2" role="group">
                                        {pageNumbers().map((p, idx) =>
                                            p === '...' ? (
                                                <span key={idx} className="btn btn-outline-primary disabled">...</span>
                                            ) : (
                                                <button
                                                    key={idx}
                                                    className={`btn btn-sm ${p === page ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => changePage(p)}
                                                    disabled={loading}
                                                >
                                                    {p}
                                                </button>
                                            )
                                        )}
                                    </div>

                                    <button
                                        className="btn btn-outline-primary btn-sm ms-2"
                                        onClick={() => changePage(page + 1)}
                                        disabled={page === totalPages || loading}
                                    >
                                        Next <i className="mdi mdi-chevron-right ms-1"></i>
                                    </button>
                                </div>

                                <div className="d-flex align-items-center">
                                    <span className="text-muted small me-2">Show</span>
                                    <select
                                        value={pageSize}
                                        className="form-select form-select-sm border-primary shadow-sm"
                                        style={{ width: '70px' }}
                                        onChange={e => {
                                            setPageSize(Number(e.target.value));
                                            setPage(1);
                                        }}
                                        disabled={loading}
                                    >
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={75}>75</option>
                                    </select>
                                    <span className="text-muted small ms-2">Records</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="bottom-right" reverseOrder={false} />
        </>
    );
}

export default Question;